import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ContentEditable from 'react-contenteditable';

import { editContent, InnerContent } from '../../../modules/editor';
import { RootState } from '../../../modules';
import { parseStyle } from '../../../util/parseStyle';

import CtaToolbar from '../Toolbar/CtaToolbar';
import useDebounce from '../../../hooks/useDebounce';

type CtaEditProps = {
	innerContent: InnerContent;
	style: any;
	contentId: number;
	contentIndex: number;
	subIndex?: number;
	markToolbar: (contentId: number, currentIndex: number, itemType:string) => void;
	markedToolbar: any
};

function CtaEdit({ innerContent, style, contentId, contentIndex, subIndex, markToolbar, markedToolbar }: CtaEditProps) {
	const dispatch = useDispatch();
	const contentEditable = useRef(null);

	
	const [buttonLink, setButtonLink] = useState(innerContent.buttonLink);
	const [showToolbar, setShowToolbar] = useState(false);
	
	const [dbButtonText, buttonText, setButtonText] = useDebounce<string>(
		innerContent.buttonText || '',
		500
		);
		
		const selectedContentId = useSelector((state: RootState) => state.editor.selectedContentId);
		const prevSelectedContentId = useSelector((state: RootState) => state.editor.prevSelectedContentId);
		const showHistory = useSelector((state: RootState) => state.editor.ui.showHistory);

	useEffect(() => {
		if (selectedContentId !== contentId) {
			setShowToolbar(false);
		}
		if (prevSelectedContentId === contentId) {
			dispatch(editContent({ target: `${contentTarget}/buttonText`, data: buttonText }));
		}
	}, [selectedContentId]);

	useEffect(() => {
		if (markedToolbar?.contentId !== contentId || markedToolbar?.currentIndex !== contentIndex || markedToolbar.itemType !== 'cta') {
			setShowToolbar(false);
		}
	}, [markedToolbar]);

	useEffect(() => {	
		setButtonText(innerContent.buttonText || '');
	}, [innerContent]);

	useEffect(() => {
		if (innerContent.buttonText === dbButtonText) {
			return;
		}
		dispatch(editContent({ target: `${contentTarget}/buttonText`, data: dbButtonText }));
	}, [dbButtonText]);

	const contentTarget = subIndex !== undefined ? `${contentId}/content/${contentIndex}/${subIndex}` : `${contentId}/content/${contentIndex}`;
	const styleTarget = subIndex !== undefined ? `${contentId}/style/${contentIndex}/${subIndex}` : `${contentId}/style/${contentIndex}`;
	

	const startEditing = () => {
		setShowToolbar(true);
		markToolbar(contentId, contentIndex, 'cta');
	}

	const onChange = (e: any) => {
		setButtonText(e.target.value);
	}

	const onPaste = (e:any) => {		
		e.preventDefault();
		const originalText = e.clipboardData.getData('text/plain').replace(/\</g, '&lt').replace(/\>/g, '&gt');
		document.execCommand('insertHTML', false, originalText);
	}

	const onKeyDown = (e:any) => {
		if (e.key === 'Enter') {
			e.preventDefault();
		}
	}

	return (
		<div className="cta-edit">
			<div
				className={showToolbar ? 'cta-edit-content active' : 'cta-edit-content'}
				style={{
					textAlign: style?.textAlign
				}}
			>
				<ContentEditable
					style={{...parseStyle(style), textAlign:'center', lineHeight: 1}}
					tagName="a"
					onChange={onChange}
					disabled={showHistory}
					html={buttonText}
					innerRef={contentEditable}
					className="cta-edit-content-editable"
					onPaste={onPaste}
					onKeyDown={onKeyDown}
				/>
			</div>
			
			{
				showToolbar ? (
					<CtaToolbar
						innerContent={innerContent}
						style={style}
						contentId={contentId}
						contentIndex={contentIndex}
						subIndex={subIndex}
					/>
				) : (
					<div 
						className="cover"
						onClick={startEditing}
					>	
					</div>
				)
			}
		</div>
	);
}

export default CtaEdit;